var _path, _path2, _path3, _path4, _path5, _path6, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo64(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64",
    width: 64,
    height: 64,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.921 33.552c.553.318 1.262.397 1.893.397 4.97 0 5.522-5.788 4.654-11.021-.947-5.55-2.997-6.899-4.102-11.18C42.105 5.8 46.6.33 52.596.013c3.233-.159 6.31 1.189 8.36 3.726.631.793 1.104 1.665 1.499 2.538 6.31 16.254-7.888 37.028-21.06 37.583-1.42.08-2.918-.08-4.337-.555a8.027 8.027 0 0 1-1.736-.713c-.552-.238-1.025-.635-1.498-1.031l-.316-.317c-.788-.952-1.34-2.22-1.34-3.568 0-3.014 2.366-5.392 5.363-5.392 1.34.08 2.445.555 3.391 1.268Z",
    fill: "url(#a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.29 33.077c.237.158.395.237.632.396 1.262.952 2.05 2.537 2.05 4.202 0 3.014-2.366 5.392-5.363 5.392-3.076 0-5.285-2.616-5.915-5.47-1.42-6.661 5.126-15.225-.947-19.348-.71-.476-1.656-.476-2.445-.476-6.862 0-8.834 11.973-8.36 17.048.236 2.14.788 4.44 1.656 6.74 1.34 3.41 3.391 6.58 3.391 10.387C24.99 58.608 19.47 64 12.685 64A12.42 12.42 0 0 1 1.88 57.736C-1.275 52.265-.171 43.86 3.063 35.772c3.47-8.8 9.464-17.364 15.143-21.408 3.707-2.696 7.966-4.52 12.541-3.647a13.78 13.78 0 0 1 4.811 1.982c1.341.872 1.972 1.586 2.84 2.934 4.653 7.374-2.919 13.796 1.893 17.444Z",
    fill: "url(#b)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.84,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.406.964c.079.634.158 1.348.158 1.982 0 6.66-5.521 12.052-12.304 12.052h-.71a16.565 16.565 0 0 1-1.183-3.171C42.105 5.8 46.6.33 52.595.012a10.07 10.07 0 0 1 4.811.952Z",
    fill: "url(#c)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.096 58.529c-2.208 3.25-5.994 5.391-10.253 5.391-.789 0-1.499-.079-2.209-.158a6.87 6.87 0 0 1-1.104-3.727c0-3.806 3.076-6.898 6.862-6.898 3.234 0 5.995 2.3 6.704 5.392Z",
    fill: "#63FFDC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.922 33.552c.552.318 1.262.397 1.893.397 4.969 0 5.521-5.788 4.654-11.022-.947-5.55-2.998-6.898-4.102-11.18-.71-3.33.395-6.422 2.445-8.642 1.262-.714 2.76-1.11 4.338-1.19 3.234-.158 6.31 1.19 8.36 3.727.632.793 1.105 1.665 1.5 2.537 4.495 11.498-1.263 25.135-9.702 32.43-2.84 1.982-5.916 3.172-8.992 3.251-1.42.08-2.918-.08-4.338-.555-.473-.158-1.025-.317-1.498-.555.63.238 1.34.397 2.05.397 2.998 0 5.364-2.38 5.364-5.392 0-.793-.158-1.507-.473-2.141-.631-1.507-1.499-2.062-1.499-2.062Zm-6.625 8.405a.953.953 0 0 1-.395-.396l-.315-.318a5.19 5.19 0 0 1-1.026-1.823c.08.158.08.238.158.396 0 .08.08.159.08.238.236.476.63 1.03 1.025 1.507.157.158.315.317.473.396Z",
    fill: "url(#d)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.714 63.762c-3.786-.634-6.862-2.934-8.676-6.105-3.155-5.471-2.05-13.876 1.183-21.964 3.47-8.801 9.465-17.364 15.144-21.408 3.47-2.538 7.493-4.282 11.752-3.806l-.079 5.074c-1.735-.634-5.52.555-8.124 1.665-6.31 2.538-8.36 13.083-7.887 18.079.237 2.14.789 4.44 1.656 6.74 1.341 3.409 3.392 6.58 3.392 10.386 0 5.233-3.47 9.753-8.36 11.339Z",
    fill: "url(#e)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 45.74,
    y1: 18.4,
    x2: 51.599,
    y2: 33.424,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7CCDFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.202,
    stopColor: "#6AC6FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.606,
    stopColor: "#3AB4FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#06A1FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 37.168,
    y1: 38.603,
    x2: 12.89,
    y2: 36.497,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#128DE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#42D4CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 54.232,
    y1: 11.216,
    x2: 45.942,
    y2: 2.97,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.002,
    stopColor: "#CEF",
    stopOpacity: 0.29
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CEF",
    stopOpacity: 0.83
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 54.523,
    y1: 38.228,
    x2: 37.08,
    y2: 8.175,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.002,
    stopColor: "#CEF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.304,
    stopColor: "#CEF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.326,
    stopColor: "#CEF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.598,
    stopColor: "#CEF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.657,
    stopColor: "#CEF",
    stopOpacity: 0.344
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CEF",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: -2.852,
    y1: 49.166,
    x2: 38.629,
    y2: 25.343,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.002,
    stopColor: "#FFFFE6",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.308,
    stopColor: "#FFFFE6",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#FFFFE6",
    stopOpacity: 0.377
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FFFFE6",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.659,
    stopColor: "#FFFFE6",
    stopOpacity: 0.085
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFFE6",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo64);
export default __webpack_public_path__ + "static/media/logo64.f64964a4f9a06e6e7b2b0f6dc9556246.svg";
export { ForwardRef as ReactComponent };